let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("P2OWY"), load("5coOi"), load("4tiwv"), load("dlm6q"), load("4XFRu"), load("hhss7"), load("eK94l")]).then(() => parcelRequire('8fb5x'));